export enum EncryptedInputFields {
  BankAccountNumber = 'encryptedBankAccountNumber',
  BankLocationId = 'encryptedBankLocationId',
  CardNumber = 'encryptedCardNumber',
  ExpiryDate = 'encryptedExpiryDate',
  ExpiryMonth = 'encryptedExpiryMonth',
  ExpiryYear = 'encryptedExpiryYear',
  SecurityCode = 'encryptedSecurityCode',
}
